import React, { useState, useEffect, useContext } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import axios from "axios";
import { apiUrl, myHeaders_Auth_With_Cache_Control } from "Api/Api";

import UserContext from "store/UserContext";

function AddEditLocationModal(props) {
  console.log("AddEditLocationModal PROPS", props);
  const location = props.locationInfo;

  const user_context = useContext(UserContext);
  const [isSwitchOn, setIsSwitchOn] = useState(true);
  const [saving, setSaving] = useState(false);
  const [validated, setValidated] = useState(false);
  const [message, setMessage] = useState(<span>&nbsp;</span>);

  const [entityName, setEntityName] = useState("");
  const [description, setDescription] = useState("");
  const [friendlyUrl, setFriendlyUrl] = useState("");
  const [cityName, setCityName] = useState("");
  const [stateProvince, setStateProvince] = useState("");
  const [coordinatesLat, setCoordinatesLat] = useState();
  const [coordinatesLon, setCoordinatesLon] = useState();
  const [country, setCountry] = useState("");
  const [statusCode, setStatusCode] = useState();

  useEffect(() => {
    const fetchLocData = async () => {
      if (props.locationInfo.entity_name) {
        try {
          const locDataResponse = await axios.get(
            `${apiUrl}locations/${props.locationInfo.entity_uuid}`,
            myHeaders_Auth_With_Cache_Control
          );
          const {
            city_name,
            coordinates_lat,
            coordinates_lon,
            country,
            description,
            state_province,
            status_code,
            friendly_url,
            entity_name,
          } = locDataResponse.data;

          setCityName(city_name);
          setDescription(description);
          setEntityName(entity_name);
          setFriendlyUrl(friendly_url);
          setCoordinatesLat(coordinates_lat);
          setCoordinatesLon(coordinates_lon);
          setCountry(country);
          setStatusCode(status_code);
          setStateProvince(state_province);
        } catch (e) {
          console.log("FAILED TO FETCH:", e);
        }
      }
    };
    fetchLocData();
  }, []);

  useEffect(() => {
    if (statusCode === 2) {
      setIsSwitchOn(false);
    }
  }, [statusCode]);
  //handle form typing
  const handleEntityNameTyping = (e) => {
    setMessage(<span>&nbsp;</span>);
    setEntityName(e.target.value);
  };
  const handleFriendlyUrlTyping = (e) => {
    setMessage(<span>&nbsp;</span>);
    setFriendlyUrl(e.target.value);
  };
  const handleDescriptionTyping = (e) => {
    setMessage(<span>&nbsp;</span>);
    setDescription(e.target.value);
  };
  const handleCityNameTyping = (e) => {
    setMessage(<span>&nbsp;</span>);
    setCityName(e.target.value);
  };
  const handleStateProvinceTyping = (e) => {
    setMessage(<span>&nbsp;</span>);
    setStateProvince(e.target.value);
  };
  const handleCoordinatesLatTyping = (e) => {
    setMessage(<span>&nbsp;</span>);
    setCoordinatesLat(e.target.value);
  };
  const handleCoordinatesLonTyping = (e) => {
    setMessage(<span>&nbsp;</span>);
    setCoordinatesLon(e.target.value);
  };
  const handleCountryTyping = (e) => {
    setMessage(<span>&nbsp;</span>);
    setCountry(e.target.value);
  };

  function closeModal() {
    props.handleClose();
    setSaving(false);
    setMessage(<span>&nbsp;</span>);
  }

  //toggle switch function and setting Team Status
  const onSwitchAction = () => {
    if (isSwitchOn) {
      setIsSwitchOn(false);
      setStatusCode(2);
    } else {
      setIsSwitchOn(true);
      setStatusCode(1);
    }
  };

  const coordIsValid = (coord, latOrLon) => {
    if (!isNaN(coord)) {
      if (latOrLon === "lat") {
        return coord >= -90 && coord <= 90;
      }
      return coord >= -180 && coord <= 180;
    }
  };

  //UPDATE a team
  async function updateLocationData() {
    if (
      !entityName.trim().length ||
      !friendlyUrl.trim().length ||
      !description.trim().length ||
      !cityName.trim().length ||
      !stateProvince.trim().length ||
      !coordinatesLon ||
      !coordinatesLat ||
      !country.trim().length
    ) {
      setMessage(
        <span style={{ color: "red" }}>Please fill out each field</span>
      );
      setValidated(true);
      return;
    } else if (!coordIsValid(coordinatesLat, "lat")) {
      setMessage(
        <span style={{ color: "red" }}>
          Latitude must be a number between -90 and 90
        </span>
      );
      setValidated(true);
      return;
    } else if (!coordIsValid(coordinatesLon, "lon")) {
      setMessage(
        <span style={{ color: "red" }}>
          Longitude must be a number between -180 and 180
        </span>
      );
      setValidated(true);
      return;
    } else {
      let locationData = {
        entity_name: entityName,
        friendly_url: friendlyUrl,
        status_code: statusCode,
        description: description,
        city_name: cityName,
        state_province: stateProvince,
        coordinates_lat: coordinatesLat,
        coordinates_lon: coordinatesLon,
        country: country,
      };

      setSaving(true);
      setMessage(<span style={{ color: "green" }}>Saving...</span>);
      if (location.entity_uuid) {
        //UPDATE THE LOCATION
        await axios.patch(
          `${apiUrl}locations/${location.entity_uuid}`,
          // locationEditPatch
          locationData
        );
      } else if (!location.entity_uuid) {
        //ADD A NEW LOCATION
        await axios.post(
          `${apiUrl}locations`,
          locationData
          // locationAddObj
        );
      }
      closeModal();
    }
  }

  const responsiveTheme =
    user_context.theme === "light"
      ? { backgroundColor: "white", color: "black" }
      : { backgroundColor: "rgb(25,25,25)", color: "white" };

  const formLabel = () => (
    <span>
      <span
        style={{
          fontWeight: !isSwitchOn ? "bold" : "lighter",
        }}
      >
        Inactive
      </span>
      <span> or </span>
      <span
        style={{
          fontWeight: isSwitchOn ? "bold" : "lighter",
        }}
      >
        Active
      </span>
    </span>
  );

  return location ? (
    <Modal show={props.show} onHide={closeModal}>
      <Modal.Header className="justify-content-around" style={responsiveTheme}>
        <h4>{location.entity_name ? "Edit City" : "Add City"}</h4>
        <Form>
          <Form.Switch
            style={{ transform: "scale(1.5)" }}
            onChange={onSwitchAction}
            id="custom-switch"
            label={formLabel()}
            checked={isSwitchOn}
          />
        </Form>
      </Modal.Header>
      <Modal.Body style={responsiveTheme}>
        <Form validated={validated} onSubmit={(e) => e.preventDefault()}>
          <Form.Group controlId="locationName">
            <Form.Label>Entity Name</Form.Label>
            <Form.Control
              type="text"
              onChange={handleEntityNameTyping}
              defaultValue={entityName}
              required
              disabled={saving}
            />
          </Form.Group>

          <Form.Group controlId="friendlyUrl">
            <Form.Label>Friendly Url</Form.Label>
            <Form.Control
              type="text"
              onChange={handleFriendlyUrlTyping}
              defaultValue={friendlyUrl}
              required
              disabled={saving}
            />
          </Form.Group>
          <Form.Group controlId="locationDescription">
            <Form.Label>Description</Form.Label>
            <Form.Control
              as="textarea"
              type="text"
              onChange={handleDescriptionTyping}
              defaultValue={description}
              required
              disabled={saving}
            />
          </Form.Group>
          <Form.Group controlId="locationCityName">
            <Form.Label>City Name</Form.Label>
            <Form.Control
              type="text"
              onChange={handleCityNameTyping}
              defaultValue={cityName}
              required
              disabled={saving}
            />
          </Form.Group>
          <Form.Group controlId="locationStateProvince">
            <Form.Label>State/Province</Form.Label>
            <Form.Control
              type="text"
              onChange={handleStateProvinceTyping}
              defaultValue={stateProvince}
              required
              disabled={saving}
            />
          </Form.Group>
          <Form.Group controlId="locationCoordinatesLat">
            <Form.Label>Coordinates (Latitude)</Form.Label>
            <Form.Control
              type="number"
              onChange={handleCoordinatesLatTyping}
              defaultValue={coordinatesLat}
              required
              disabled={saving}
            />
          </Form.Group>
          <Form.Group controlId="locationCoordinatesLon">
            <Form.Label>Coordinates (Longitude)</Form.Label>
            <Form.Control
              type="number"
              onChange={handleCoordinatesLonTyping}
              defaultValue={coordinatesLon}
              required
              disabled={saving}
            />
          </Form.Group>
          <Form.Group controlId="locationCountry">
            <Form.Label>Country</Form.Label>
            <Form.Control
              type="text"
              onChange={handleCountryTyping}
              defaultValue={country}
              required
              disabled={saving}
            />
          </Form.Group>
        </Form>
        {message}
      </Modal.Body>
      <Modal.Footer style={responsiveTheme}>
        <Button variant="secondary" onClick={() => closeModal()}>
          Close
        </Button>
        <Button variant="pkprimary" onClick={() => updateLocationData()}>
          Save City
        </Button>
      </Modal.Footer>
    </Modal>
  ) : (
    <div />
  );
}

export default AddEditLocationModal;
